import * as Dialog from '@radix-ui/react-dialog';
import PropTypes from 'prop-types';
import type { ReactNode } from 'react';

import './Drawer.scss';

type Props = {
  children: ReactNode;
  isOpen: boolean;
  onClose: (_open: boolean) => void;
};

export function Drawer({ children, isOpen, onClose }: Props) {
  return (
    <Dialog.Root open={isOpen} onOpenChange={onClose}>
      <Dialog.Portal>
        <Dialog.Overlay className='Drawer__overlay' />
        <Dialog.Content aria-describedby={undefined} className='Drawer__content'>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

Drawer.propTypes = {
  children: PropTypes.node.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
